import { render, staticRenderFns } from "./CommentsModal.vue?vue&type=template&id=1104428c&scoped=true"
import script from "./CommentsModal.vue?vue&type=script&lang=js"
export * from "./CommentsModal.vue?vue&type=script&lang=js"
import style0 from "./CommentsModal.vue?vue&type=style&index=0&id=1104428c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1104428c",
  null
  
)

export default component.exports